module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_p01_r1.htm"
    }
  }, [_vm._v("ONE DAY THEY WOKE AND FOUND THEIR LIVES HAD CHANGED")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c01_r1.htm"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c02_r1.htm"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c03_r1.htm"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c04_r1.htm"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c05_r1.htm"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c06_r1.htm"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c07"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c07_r1.htm"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c08"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c08_r1.htm"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c09"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c09_r1.htm"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c10_r1.htm"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c11_r1.htm"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c12_r1.htm"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c13"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c13_r1.htm"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c14"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c14_r1.htm"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c15"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c15_r1.htm"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "p02"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_p02_r1.htm"
    }
  }, [_vm._v("THE HERON DIES IN FLIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c16"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c16_r1.htm"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c17"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c17_r1.htm"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c18"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c18_r1.htm"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c19"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c19_r1.htm"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c20"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c20_r1.htm"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c21"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c21_r1.htm"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c22"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c22_r1.htm"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c23"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c23_r1.htm"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c24"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c24_r1.htm"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c25"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c25_r1.htm"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c26"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c26_r1.htm"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c27"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c27_r1.htm"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c28"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c28_r1.htm"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c29"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c29_r1.htm"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c30"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c30_r1.htm"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "p03"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_p03_r1.htm"
    }
  }, [_vm._v("THE END AND THE BEGINNING OF THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c31"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c31_r1.htm"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c32"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c32_r1.htm"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c33"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c33_r1.htm"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c34"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c34_r1.htm"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c35"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c35_r1.htm"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c36"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c36_r1.htm"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c37"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c37_r1.htm"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c38"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c38_r1.htm"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c39"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c39_r1.htm"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c40"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c40_r1.htm"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c41"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c41_r1.htm"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c42"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c42_r1.htm"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c43"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c43_r1.htm"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c44"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c44_r1.htm"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c45"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c45_r1.htm"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c46"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c46_r1.htm"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c47"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c47_r1.htm"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c48"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c48_r1.htm"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "p04"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_p04_r1.htm"
    }
  }, [_vm._v("CARRY ME LIKE WATER")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c49"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c49_r1.htm"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c50"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c50_r1.htm"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c51"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c51_r1.htm"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c52"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c52_r1.htm"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c53"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c53_r1.htm"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c54"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c54_r1.htm"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c55"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c55_r1.htm"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c56"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c56_r1.htm"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c57"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c57_r1.htm"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c58"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c58_r1.htm"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c59"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c59_r1.htm"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c60"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c60_r1.htm"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c61"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c61_r1.htm"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c62"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c62_r1.htm"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c63"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c63_r1.htm"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c64"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c64_r1.htm"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c65"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c65_r1.htm"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c66"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c66_r1.htm"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c67"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_c67_r1.htm"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_ack_r1.htm"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ata"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_ata_r1.htm"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "col"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_col_r1.htm"
    }
  }, [_vm._v("Praise for CARRY ME LIKE WATER")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "adc"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_adc_r1.htm"
    }
  }, [_vm._v("Also by Benjamin Alire Sáenz")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "cop"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062045980_epub_cop_r1.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "pub"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/About_the_Publisher.htm"
    }
  }, [_vm._v("About the Publisher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b6e34f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062045980_epub_toc_r1.vue
// module id = 69
// module chunks = 0